import { EventBus } from '../index'

export default {
  inject: ['stateName'],
  data: () => ({
    showContextMenu_: false,
    x: 0,
    y: 0
  }),
  computed: {
    showContextMenu: {
      get: function () {
        return this.showContextMenu_
      },
      set: function (value) {
        if (value && this.$store.state[this.stateName].isContextMenuVisible) {
          return
        }
        this.showContextMenu_ = value
        this.$store.commit(`${this.stateName}/setIsContextMenuVisible`, value)
      }
    },
    actualModel() {
      return this.model || this.row || this.value || {}
    },
    jpModuleName() {
      return this.$store.state.global.currentModuleRouteParam
    }
  },
  methods: {
    onShowContextMenu(e) {
      if (!this.isInEditorMode) {
        return
      }
      e.preventDefault()
      this.x = e.clientX
      this.y = e.clientY
      this.showContextMenu = true
      if (this.showContextMenu) {
        this.selectComponent(this.actualModel)
      }
    },
    onCreateSnippet() {
      EventBus.$emit('createSnippet', {
        model: this.actualModel,
        callback: (newWidget) => {
          this.$emit('replaceComponent', { oldModel: this.actualModel, newModel: newWidget })
        }
      })
    },
    // Удаление виджета из контекстного меню
    onDeleteComponentFromContextMenu(value) {
      this.$emit('deleteComponent', value)
    },
    // Вставить скопированный виджет
    onPasteCopiedWidget(widget) {
      // если скопированную строку вставить в dr-grid-layout
      if (this.model && 'Rows' in this.model) {
        this.model.Rows.push(widget)
        this.$emit('modelChanged', this.model)
        this.$store.dispatch('jsonPatches/createAddPatch', {
          selectedWidget: widget,
          pathToTarget: `Modules.${this.jpModuleName}`,
          value: widget,
          publish: true
        })
        
        return
      }
      // если скопированную колонку вставить в строку dr-grid-layout
      if (this.row && 'Columns' in this.row) {
        this.row.Columns.push(widget)
        this.$emit('modelChanged', this.row)
        this.$store.dispatch('jsonPatches/createAddPatch', {
          selectedWidget: widget,
          pathToTarget: `Modules.${this.jpModuleName}`,
          value: widget,
          publish: true
        })
        return
      }
      // для остальных виджетов
      if (this.model && 'Widgets' in this.model) {
        this.model.Widgets.push(widget)
        this.$emit('modelChanged', this.model)
        this.$store.dispatch('jsonPatches/createAddPatch', {
          selectedWidget: widget,
          pathToTarget: `Modules.${this.jpModuleName}`,
          value: widget,
          publish: true
        })
        return
      }
    }
  },
  destroyed() {
    this.$store.commit(`${this.stateName}/setIsContextMenuVisible`, false)
  }
}
